import { useRouter } from "next/router";
import type { Locales } from "~/i18n/i18n-types";

import { type Locale, arSA, ca, enUS, es, ptBR, et, ru } from "date-fns/locale";

const useCalendarLocale = (): Locale => {
	const { locale: nextLocale } = useRouter();
	const locale = (nextLocale ?? "en") as Locales;

	switch (locale) {
		case "ar":
			return arSA;
		case "es":
			return es;
		case "pt":
			return ptBR;
		case "ca":
			return ca;
		case "ee":
			return et;
		case "ru":
			return ru;
		default:
			return enUS;
	}
};

export default useCalendarLocale;
